import { useEffect, useState } from 'react';
import { TaskSidebarPanel } from './TaskSidebarPanel';
import { buildSidebarTabs, REFINEMENT_TABS } from './taskSidebarTabs';
import { useRefinementDesignConversation } from './useRefinementDesignConversation';

interface RefinementDesignSidebarProps {
    patientId: string;
    /** Scopes the Revisions tab to the current refinement cycle. */
    since?: string | null;
    /** Extra affordance for the Revisions tab header (e.g. "Request clarification"). */
    revisionsHeaderAction?: React.ReactNode;
}

export function RefinementDesignSidebar({
    patientId,
    since = null,
    revisionsHeaderAction
}: RefinementDesignSidebarProps) {
    const { revisionCount } = useRefinementDesignConversation(patientId, since);
    const [activeKey, setActiveKey] = useState('notes');
    const [hasUserSelected, setHasUserSelected] = useState(false);

    // Land on Revisions once the history resolves with entries, unless the
    // user has already picked a tab themselves.
    useEffect(() => {
        if (!hasUserSelected && revisionCount > 0) {
            setActiveKey('refinement-revisions');
        }
    }, [revisionCount, hasUserSelected]);

    return (
        <TaskSidebarPanel
            activeKey={activeKey}
            onActiveKeyChange={(key) => {
                setHasUserSelected(true);
                setActiveKey(key);
            }}
            tabs={buildSidebarTabs(patientId, REFINEMENT_TABS, since, { revisionsHeaderAction })}
        />
    );
}
